import React from 'react';
import { ColDef } from 'ag-grid-community';
import { Icon } from 'semantic-ui-react';
import get from 'lodash/get';
import { getFundsDesignationTextByValue } from 'erisxkit/client';
import { ReconciliationDataType } from './ReconciliationGrid';

const getColumnDefs = (viewReconciliations: (id: string) => void): ColDef[] => [
  {
    field: 'firmCode',
    headerName: 'Firm Code',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'accountCode',
    headerName: 'Account Code',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'name',
    headerName: 'Account Name',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'subExchangeLabel',
    headerName: 'Subexchange',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'provider',
    headerName: 'Provider',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'providerAccountId',
    headerName: 'Provider Account Id',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    field: 'fundsDesignation',
    headerName: 'Funds Designation',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
    valueGetter: ({ data = '' }) => {
      const value = get(data, 'fundsDesignation', '');
      return getFundsDesignationTextByValue(value) || value;
    },
  },
  {
    field: 'assetType',
    headerName: 'Asset Type',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
    valueGetter: ({ data }) => {
      return get(data, 'balances', {})[
        get(data, 'assetType', '').toLowerCase()
      ];
    },
    cellClass: 'text-right mono',
  },
  {
    field: 'action',
    headerName: '',
    initialWidth: 100,
    cellRenderer: ({ data }: { data?: ReconciliationDataType }) => (
      <span>
        {
          <Icon
            link
            title="View Reconciliation History"
            onClick={() => {
              viewReconciliations(data?.accountId || '');
            }}
            color="grey"
            name="arrow alternate circle right outline"
          />
        }
      </span>
    ),
    filter: false,
  },
];

export default getColumnDefs;
